// extracted by css-extract-rspack-plugin
export default {"cls1":"TriagePage-cls1_FxY","cls2":"TriagePage-cls2_0G4 TriagePage-cls1_FxY"};